import React, { Component } from 'react';

export default class AboutHeader extends Component {
  render() {
    return <div className="about-header">About</div>;
  }
}
